'use client';

import { action, makeObservable, observable } from 'mobx';

export class UseCasesStore {
  showRiskSuggestion = false;

  useCaseId = undefined;

  constructor() {
    makeObservable(this, {
      showRiskSuggestion: observable,
      useCaseId: observable,
      setshowRiskSuggestion: action.bound,
      setUseCaseId: action.bound,
    });
  }

  setshowRiskSuggestion(value: boolean) {
    this.showRiskSuggestion = value;
  }

  setUseCaseId(value: number) {
    this.useCaseId = value;
  }
}

export const usecaseStore = new UseCasesStore();
